import { render, staticRenderFns } from "./MarketDevelopment.vue?vue&type=template&id=a541c144&scoped=true&"
import script from "./MarketDevelopment.vue?vue&type=script&lang=js&"
export * from "./MarketDevelopment.vue?vue&type=script&lang=js&"
import style0 from "./MarketDevelopment.vue?vue&type=style&index=0&id=a541c144&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a541c144",
  null
  
)

export default component.exports